import { SearchTravelPlaningPayload } from 'leash/types';
import { apiGetRequest, apiPostRequest } from 'utilities/http/api/apiHttp';
import { TravelPlan } from 'types';

export const apiContent = {
  getLeashContent: () =>
    apiGetRequest<{ travelPlanningContent: unknown }>('travel/planning/content'),

  searchTravelPlanning: (payload: SearchTravelPlaningPayload) =>
    apiPostRequest<{ travelPlans: TravelPlan[] }>('travel/planning/search', payload),
};
